// removed by extract-text-webpack-plugin
module.exports = {"primary":"#00B0EB","primaryHover":"#006f94","primaryLight":"#66D1F4","onPrimaryTextColor":"white"};


//////////////////
// WEBPACK FOOTER
// ./client/css/global/core.css
// module id = 1974
// module chunks = 0